const Signin: React.FC = () => {
  return <div>ADMIN SIGNIN</div>;
};

export default Signin;
